module.exports = __webpack_public_path__ + "static/media/19-5.adc0f168.mp3";